<jhi-bary-card [titleKey]="title">
  <div body>
    <form autocomplete="off" *ngIf="isEditMode">
      <div class="row" *ngIf="addressForm">
        <div class="col-12">
          <jhi-bary-address-form [id]="id + '.address'" [addressForm]="addressForm" [options]="options" [touched]="touched"></jhi-bary-address-form>
        </div>
      </div>
    </form>
    <ng-container *ngIf="!isEditMode && address">
      <ul class="striped list-unstyled">
        <li class="mb-1">
          <span class="font-weight-bold">{{ 'LABEL.COMPANY_NAME' | translate }}&nbsp;:</span>
          <span data-id-cypress="address-company-name">{{ address.fullname }}</span>
        </li>
        <li class="mb-1">
          <span class="font-weight-bold">{{ 'LABEL.ADDRESS' | translate }}&nbsp;:</span>
          <span data-id-cypress="address-full-adress">{{ address.toString }}</span>
        </li>
        <li class="mb-1">
          <span class="font-weight-bold">{{ 'LABEL.ADDITIONAL_ADDRESS' | translate }}&nbsp;:</span>
          <span data-id-cypress="address-additionals">{{ address.additionals }}</span>
        </li>
        <li class="mb-1" *ngIf="isBillAdress(address)">
          <span class="font-weight-bold">{{ 'LABEL.BILL_EMAIL' | translate }}&nbsp;:</span>
          <span data-id-cypress="address-bill-mail">{{ address.billEmail }}</span>
        </li>
      </ul>
    </ng-container>
  </div>
  <div footer class="bg-white p-3" *ngIf="switchButton">
    <div class="d-flex justify-content-end">
      <jhi-bary-button
        data-id-cypress="btn-update-address"
        *ngIf="!isEditMode"
        (click)="isEditMode = true"
        class="btn bary-btn mx-6"
        icon="pen"
        [label]="'BTN.MODIFY' | translate"
      ></jhi-bary-button>
      <jhi-bary-button
        *ngIf="isEditMode"
        class="btn bary-btn mr-3"
        icon="times"
        color="danger"
        [label]="'BTN.CANCEL' | translate"
        (click)="isEditMode = false; action.emit(false)"
      ></jhi-bary-button>
      <jhi-bary-button
        *ngIf="isEditMode"
        (click)="isEditMode = false; action.emit(true)"
        data-id-cypress="button-save-adress"
        [disabled]="!!addressForm?.getAngularForm()?.invalid"
        [label]="'BTN.SAVE' | translate"
        icon="save"
      ></jhi-bary-button>
    </div>
  </div>
</jhi-bary-card>
